<template lang="pug">
//-v-container.style-login(fluid)
    v-row
        v-col
            v-card
                v-card-text
                    p Lorem
v-layout.style-login(justify-center)
    v-flex(xs12, style="max-width:1000px;")
        v-card(flat, dark, color="transparent")
            v-card-text
                v-layout(row,wrap).mt-10.pt-10
                    v-flex(xs12).text-center
                        img.text-xs-center(src="https://sisep.minedu.gob.bo/img/ugpsep-white.png", :width="logoHome")
                        div.yellow.darken-3(style="border-radius:2px;width:100%;height:2px;margin-top:4px;margin-bottom:12px")
                        h2.white--text Sistema SISEP {{ version }}
                        //- h3.yellow--text Nro. de visitantes: {{ NroVistas }}
</template>

<script>
module.exports = {
    data() {
        return {
            a: 'b',
            NroVistas: 0,
            newversion: 0,
            version: null
        };
    },
    computed:{
        showLogo(){
            if(this.$store.state.windowSize.w>550){
                return true;
            }
            else{
                return false;
            }
        },
        logoHome(){
            if(this.$store.state.windowSize.w>550){
                return "600px";
            }
            else{
                return "350px";
            }
        }
    },
    methods: {
        async loadCounter(){
            try {
                this.NroVistas = await axios.get('/api/v1/get-counter');
            } catch (error) {
                this.NroVistas = 0
            }
        }
    },
    async mounted(){
        this.version = " - versión " + document.title.substr(document.title.length - 5)
        /*try {
            let resp = await axios.get("http://sisep.minedu.gob.bo:8083/info/sisep-info");
            this.version = " - versión " + resp.data.version;
        } catch (error) {
            this.version = null;
        }*/
    },
    created: function() {
        //this.loadCounter();
    }
};
</script>
